<template>
  <v-dialog v-model="showDialog" persistent style="z-index:10011;">
    <div class="dialog_card
                background_neutral_white
                border_stroke_sm_df
                border_color_neutral_default
                border_rounded_md_df
                gray-shadow-sm-df"
    >

      <!-- Title -->
      <div class="card_title padding-right_sm padding-top_sm padding-left_sm padding-bottom_xs-df">
        <SvgFactory name="icon_user_card" :width=18 class="margin-right_xs-df" />
        <span class="bold-body-md typography_default">
          Select the profile
        </span>
        <SvgFactory
          name="icon_close"
          :width=18
          style="margin-left: auto; cursor: pointer;"
          @click="$emit('close')"
          @keydown="$emit('close')"
        />
      </div>

      <!-- card_body -->
      <div class="card_body padding_md">
        <div class="flex_vertical">
          <div v-if="accountAliases === null" class="loading">
            <IconnectionsLoader />
          </div>
          <div
            v-else
            v-for="aliasAccount in accountAliases"
            :key="aliasAccount.contactGUID"
            class="alias_card
                    border_stroke_sm_df
                    border_color_neutral_default
                    border_rounded_md_df
                    gray-shadow-sm-df
                    margin-bottom_sm
                    padding_sm
                    flex_horizontal"
            :class="`${infoUser.email === aliasAccount.email ? 'background_primary_brand_color' : 'background_neutral_white'}`"
          >
            <div class="alias_card-info">
              <CompanyTypeBadge
                class="margin-bottom_xs-df"
                :companyType="getCompanyType(aliasAccount.companyTypeId)"
              />
              <p class="regular-body-md typogpraphy_light margin-bottom_2xs">
                <span class="bold-body-md typogpraphy_dark">
                  {{ aliasAccount.isRootAccount ? 'MAIN - ' : '' }}
                </span>
                {{ aliasAccount.name }}
              </p>
              <p class="regular-body-md typogpraphy_light margin-bottom_2xs">
                {{ aliasAccount.email}}
              </p>
              <p class="regular-body-md typogpraphy_light margin-bottom_2xs">
                {{ aliasAccount.compaynName }}
              </p>
            </div>
            <div class="alias_card-cta">
              <IConnButton
                class="margin-bottom_sm"
                :text="`${infoUser.email !== aliasAccount.email ? 'Login' : 'Current'}`"
                :type="`${aliasAccount.isRootAccount ? 'primary' : 'secondary'}`"
                :loading="loading"
                :disabled="infoUser.email === aliasAccount.email"
                @onClick="loading = true; $emit('userSelected',
                                                {
                                                  contactGUID: aliasAccount.contactGUID,
                                                  companyGUID: aliasAccount.companyGUID,
                                                  email: aliasAccount.email
                                                })"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- CTA -->
      <div class="card_cta padding_sm flex_horizontal">
        <IConnButton
          class="margin-right_sm"
          type="primary"
          text="Cancel"
          :fullWidth=true
          :loading="loading"
          @onClick="$emit('close')"
        />
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

import IconnectionsLoader from '@design_system_v2/atoms/IconnectionsLoader.vue';
import SvgFactory from '@design_system_v2/atoms/SvgFactory.vue';
import CompanyTypeBadge from '@design_system_v2/atoms/CompanyTypeBadge.vue';
import IConnButton from '@design_system_v2/atoms/Button.vue';

export default {
  name: 'ChangeUserModal',
  emits: ['userSelected', 'close'],
  components: {
    IconnectionsLoader,
    SvgFactory,
    CompanyTypeBadge,
    IConnButton,
  },
  props: {
    show: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('main', ['infoUser']),
    accountAliases() {
      return this.$store.getters['main/accountAliases'];
    },
  },
  watch: {
    show: {
      immediate: true,
      handler() {
        this.showDialog = this.show;
      },
    },
  },
  data() {
    return {
      showDialog: false,
      loading: false,
    };
  },
  mounted() {
    this.$store.dispatch('main/getAliases');
  },
  methods: {
    getCompanyType(companyTypeId) {
      switch (companyTypeId) {
      case 1:
        return 'Fund';
      case 2:
        return 'Investor';
      case 3:
        return 'Service Provider';
      case 4:
        return 'iConnections';
      case 5:
        return 'Speaker';
      case 6:
        return 'Guest';
      case 7:
        return 'Media';
      case 8:
      default:
        return 'Other';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@foundation";

.dialog_card {
  width: 600px;
  margin-left: auto;
  margin-right: auto;
  overflow-y: auto;

  .card_title {
    display: flex;
    align-items: center;
    border-bottom: 1px solid map-get($neutral, 'neutral-300');
  }

  .card_body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    border-bottom: 1px solid map-get($neutral, 'neutral-300');
  }
}

.alias_card {
  width: 500px;

  &-info {
    width: 100%;
    text-align: left;
  }

  &-cta {
    display: flex;
    align-items: center;
  }
}

.loading {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
}
</style>
